
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-235beab2&scoped=true!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Unsupported.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Unsupported.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-235beab2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Unsupported.vue"),
  /* scopeId */
  "data-v-235beab2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/Unsupported.vue
// module id = 615
// module chunks = 0